<!--  -->
<template>
    <div class="operation-guide-detail">
        <collapse v-model="activeNames">
            <collapse-item name="1">
                <template #title>
                    <div class="guide-detail flex align-center">
                        <img src="../../assets/images/operationGuide/question.png" alt="" />
                        <p>{{ detail.title }}</p>
                    </div>
                    <div class="date">2021-08-15 15:45</div>
                </template>
                <div class="text" v-html="detail.content"></div>
                <template #right-icon><div></div></template>
            </collapse-item>
        </collapse>
    </div>
</template>

<script>
import { Collapse, CollapseItem } from "vant";
export default {
    name: "oprationGuideDetail",
    components: {
        Collapse,
        CollapseItem,
    },
    data() {
        return {
            detail: {},
            activeNames: ["1"],
        };
    },

    mounted() {
        this.detail = this.$route.params;
    },

    methods: {},
};
</script>
<style lang="less" scoped>
.operation-guide-detail {
    margin-top: 10px;
    height: 100%;
    width: 100%;
    background-color: #fff;

    .date {
        font-size: 24px;
        color: #999999;
    }
    .text {
        color: #000;
        font-size: 32px;
    }
}

.guide-detail {
    div {
        width: 32px;
        height: 32px;
    }

    img {
        width: 32px;
        height: 32px;
    }
    p {
        font-size: 32px;
        color: #333333;
        margin-left: 17px;
    }
}
</style>
